"use strict";

/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BufferSerialiser = exports.BufferSerialiserClass = void 0;
/**
 * A Serialiser for buffers values
 */
var BufferSerialiserClass = /** @class */function () {
  function BufferSerialiserClass() {}
  /**
   * @inheritdoc
   *
   * Assumes that the remainder of the input stream should be read
   * This does not store the length of the buffer, so beware
   */
  BufferSerialiserClass.prototype.read = function (bis) {
    return bis.readMany(bis.count - bis.pos);
  };
  /**
   * @inheritdoc
   */
  BufferSerialiserClass.prototype.write = function (bos, val) {
    bos.writeMany(val);
  };
  return BufferSerialiserClass;
}();
exports.BufferSerialiserClass = BufferSerialiserClass;
/**
 * The {@link BufferSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.BufferSerialiser = new BufferSerialiserClass();